<template>
  <div class="delete-site-inspection-dialog">
    <v-card>
      <v-card-title>점검기록 삭제</v-card-title>
      <v-card-text>
        <div>{{ item.title }}</div>
        <div>정말로 이 기록을 삭제하시겠습니까?</div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text color="error" @click="deleteInspection(item.id)">삭제</v-btn>
        <v-btn text @click="dialog.deleteInspectionDialog = false">취소</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'deleteInspectionDialog',
    props: {
      dialog: {
        type: Object,
        required: true
      },
      item: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
      }
    },
    methods: {
      deleteInspection(inspectionId) {
        const retryFuncBackup = this.deleteInspection.bind(this, inspectionId);

        const urlEncodedInspectionId = encodeURIComponent(inspectionId);
        console.log(`id : ${inspectionId}, encoded : ${urlEncodedInspectionId}`);

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/siteInspections/${urlEncodedInspectionId}`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        axios.delete(targetUri, config)
          .then(result => {
            this.popupAlert('점검기록 삭제 성공', 'green');
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
            this.dialog.deleteInspectionDialog = false;
            this.refreshSiteInspections();
          });
      },
      printDebugLog(target) {
        console.dir(target);
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      },
      refreshSiteInspections() {
        this.$bus.$emit('refreshSiteInspections');
      }
    },
    mounted() {
    }
  }
</script>